import React from "react"

const SpaParts = () => {
  return <h1>Spa Parts</h1>
}

export default SpaParts
